var sponsoredProducts = function sponsoredProducts(products) {
  return products == null ? void 0 : products.filter(function (_ref) {
    var ads = _ref.ads;
    return ads == null ? void 0 : ads.sponsored;
  });
};
export default sponsoredProducts;